export const DATE_FORMAT_DATE = 'DD.MM.YY';
export const DATE_FORMAT_TIME = 'HH:mm';
export const DATE_FORMAT_DATETIME = `${DATE_FORMAT_DATE} ${DATE_FORMAT_TIME}`;

export const DATE_FORMAT_API_DATE = 'YYYY-MM-DD';
export const DATE_FORMAT_API_DATETIME = `${DATE_FORMAT_API_DATE}T${DATE_FORMAT_TIME}`;
